
import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import lockBlue from '../../../img/lock_blue.png';
import lockRed from '../../../img/lock_red.png';
import constants from '../../../constants';
import Select from "../../../ui/Select";
import {Search} from "../../../filtering";
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import {
  DateRenderer,DateTimeRenderer,FloatRenderer,NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, { IJobListViewContext, RightClickContext } from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import PrimaryButton from '../../../ui/PrimaryButton';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import {JobNames} from "../../../framework.core/JobNames";
import {OtherOperationListItem} from "../../../fms.data/models/OtherOperationListItem";
import {otherShipmentList} from "../tableSettings";
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BillingsRenderer, BillInvoiceCrdbFilterRenderer, LastEventRenderer, RecognizedFilterRenderer, RecognizedRenderer, RQFilterRenderer, ShipmentTypeRenderer } from '../../common/commonListRenderers';
import * as XCol from '../../../framework.core/XExportColumn';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import postal from 'postal';
import loadInfoAreaInvoiceBillCrDb from '../../common/InfoAreaInvoiceBillCrDb';
import { FmsSecTask } from '../../../fms.core/constants';
import { getFmsGlobal } from '../../../globals';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask } from '../../../util';
import { useJournal } from '../../accounting/general/journal/JournalListView';
import useSuntekSettings from '../../../hooks/useSuntekSettings';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';
import _ from 'lodash';
import fastStorage from '../../../fastStorage';
import RecogModal from '../../../ui/RecogModal';
import useSetEditedId from '../../../hooks/useSetEditedId';
import { RequestType } from '../../../fms.core/TrackRequest';
import { ApiResult } from '../../../framework.core/data/ApiResult';
import TrackingRequest from '../../reports/TrackingRequest';
import EmailOptionPopup from '../../reports/EmailOption';
import MblMilestonePopup from './MblMilestonePopup';
import { Decimalformat, nullableCheckBoxValue } from '../../common/commonExportFormat';
import cntrBlack from '../../../img/container_tracking-black.svg';
import cntrWhite from '../../../img/container_tracking-white.svg';
import UseAMSISfIcon from '../../../img/Isf_P_circle.svg';
import CheckBoxIcon from "../../../ui/CheckBoxIcon";

let vcResult = '';

function ShipmentTypeFilterRenderer({value, onChange}:any) {
  useEffect(() => {
      if (value !== unFormatShipmentType(value)) {
        onChange(unFormatShipmentType(value))
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <Select
      name='ifms-filter-shipmentType-select'
      value={unFormatShipmentType(value)}
      onChange={e => onChange(e.target.value)}
      items={[
        { label: 'D - Direct Shipment', value: 'D' },
        { label: 'ID - InDirect Shipment', value: 'I' }
      ]}      
    />
  );
}

function formatShipmentType(s:string|null|undefined) {
  if (!s) {
    return s;
  }

  if (s === 'I') {
    return 'ID';
  }
  if (s === 'D') {
    return 'D';
  }

  return s;
}

function unFormatShipmentType(s:string|null|undefined) {
  if (!s) {
    return '';
  }

  if (s === 'ID') {
    return 'I';
  }
  if (s === 'D') {
    return 'D';
  }

  return '';
}

// function CurrencyRenderer(value: number | null | undefined, currency: string, isLast: boolean = false) {
//   return (
//     <div style={{height: '100%'}}>
//       <div style={{paddingTop: '0px', lineHeight: '12px', paddingRight: !isLast ? '15px' : '25px', textAlign: 'right'}}>
//         <CurrencyLabel currency={currency} value={value}/>
//       </div>
//     </div>
//   );
// }

function IndicatorRenderer({ data, row }: any) {
  //const jobListContext = useContext(JobListViewContext);
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  //if ((l as any).isClosed) {
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="7px" src={lockBlue} id={'blueIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  //}
  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function PaidRenderer({value, data, row}: any) {
  const {switchToAcctInfo} = useSelectedOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}
/*
function AccountingEntityRenderer(onLinkToAccounting: any, {data, row, value}: any) {
  const entity = data[row.index];

  return <div style={{marginTop: '0px', marginLeft: '5px', textAlign: 'left'}}>
    <button className="e-btn e-small e-link" style={{margin: '0', padding: '0', lineHeight: '12px', color: '#0d7757'}}
            onClick={() => onLinkToAccounting(entity)}>{value}</button>
    &nbsp;
  </div>;
}
*/

function IsfRenderer({ cell, row, data }: any) {
  const l = data[row.index];
  const useIsf = (l as any).useIsf as boolean;

  if (useIsf) {
    if (cell && cell.value) {
      return (
        <div className="ifms-table-align-left" id={`ifms-table-align-left-${row.index}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', minHeight: '22px' }}><img height="13px" src={UseAMSISfIcon} alt="" /></div>
      );
    }
  } else {
    if (cell && cell.value) {
      return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default">
        <CheckBoxIcon value={true} />
      </div>;  
    }
  }

  return <div className="ifms-table-align-center" id={`ifms-table-default-${row.index}`} >x</div>;
}

function InbondRenderer({ cell, row, data }: any) {
  const l = data[row.index];

  if (!!l.itNo) {
    if (cell && cell.value) {
      return (
        <div className="ifms-table-align-left" id={`ifms-table-align-left-${row.index}`}>{l.itNo}</div>
      );
    }
  } else {
    if (cell && cell.value) {
      return <div className="ifms-table-align-center" id={`ifms-table-default-${row.index}`} >x</div>;
    }
  }
  return <div className="ifms-table-align-center" id={`ifms-table-default-${row.index}`} >x</div>;
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();

  const selectedElement = jobListContext.selectedElement as OtherOperationListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const channel = postal.channel('ajax');

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/otherShipment/otherShipment/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    openNewPage(history, '/otherShipment/otherShipment/add', NavigationType.newPage);
  }

  async function deleteItem() {
    if (!selectedElement) {
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/otherShipment/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/otherShipment/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close B/L first', false, null, "warning");
      return;
    }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/OTOP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/OTOP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/OTOP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/OTOP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/OTOP/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/OTOP/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first.');
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.OtherOP, { id:selectedElement.id, pimsLinkId: 0 });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');
      }
    }
  }

  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const viewUrl = `/otherShipment/viewBillings/${id}`;
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function moveToDeleteHistoryReport() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.OtherOP}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function viewProfit(viewEdit:boolean) {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    
    const editUrl  = `/otherShipment/otherShipment/edit/${id}`;
    const viewUrl = `/otherShipment/otherShipment/view/${id}`;
    //let url = `/otherShipment/otherShipment/${viewEdit ? 'edit' : 'view'}/${id}`;

    let editUrlProfitTab = `${editUrl}/2`;
    let viewUrlProfitTab = `${viewUrl}/2`;

    if (viewEdit && jobListContext.hasOpenedScreenStartingWithUrlWithoutMe(`/otherShipment/otherShipment/edit`, editUrl)) {
      await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
      return;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewEdit ? editUrlProfitTab : viewUrlProfitTab, [viewUrl, editUrl]);
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/otherShipment/otherShipment/edit/${id}`;
    const viewUrl = `/otherShipment/otherShipment/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/otherShipment/otherShipment/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }
    
    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/otherShipment/otherShipment/edit/${id}`;
    const viewUrl = `/otherShipment/otherShipment/view/${id}`;
    const listSec = findSecurityTask(appContext, FmsSecTask.OtherOP);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/otherShipment/otherShipment/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/otherShipment/otherShipment/add?copyId=${id}`, NavigationType.newPage);
  }

  function recognize(isSet: boolean) {
    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }

  async function switchToAcctInfo(ot:OtherOperationListItem|null) {
    if (!ot) {
      return;
    }
    
    openNewPage(history, `/accounting/Acct/${JobNames.OtherOP}/${ot.id}`, NavigationType.newPage);
  }

  function switchToContainerFor() {
    if (!selectedElement) {
      return;
    }
  
    jobListContext.setFilterForScreenExternally('/common/joblistview/OTOPC/otherShipment', 
      //'refNo', 'Ref No', mbl.refNo ?? '', 'updated', false
      // 'refNo', '', mbl.refNo ?? '', 'update', false);
      'genMainId', 'Ref. #', selectedElement.id, 'update', false, true, null, 'refNo', selectedElement.refNo, false, true);
    openNewPage(history, `/common/joblistview/OTOPC/otherShipment`, NavigationType.newPage);
  }

  async function trackRequestFunc() {
    if (!selectedElement) {
      return;
    }

    if (_.isEmpty(selectedElement.container)) {
      await showGlobalOkDialog(<p>Empty container number.</p>);
      return;
    }

    const plusIndex = selectedElement.container.indexOf('+');
    let containerCount: number = 1;

    if (plusIndex !== -1) containerCount = Number(selectedElement.container.substring(plusIndex + 1).trim()) + 1

    await CheckAndDoTrackRequest(selectedElement.id, selectedElement.trType, selectedElement.trStatus, selectedElement.mblNo, containerCount)
  }

  async function CheckAndDoTrackRequest(jobId: number, trType: string, trStatus: string, mblNo: string, cntrCount: number = 1) {
    let result: string = '';
    if (!await CheckTrStatus(jobId, trType, trStatus, cntrCount)) return result;
    
    const apiResult = await IsShippingLineSupported(mblNo?.substring(0, 4), RequestType.bl)
    if (!apiResult.success)
      return result;

    vcResult = apiResult.result;

    const errMsg = await CheckTrackRequestAllowed(cntrCount)
    if(!_.isEmpty(errMsg)){
      if (!errMsg.endsWith('?')){
        await showGlobalOkDialog(<p>{errMsg}</p>);
        return result;
      }
      else{
        const doClose = await showGlobalYesNoDialog(
          <div>
            <h3>{errMsg}</h3>
          </div>
        ,false, 0, true);
  
        if (!doClose) {
          return result;
        }
      }
    }

    jobListContext.setRowExtrasId(jobId);
    jobListContext.setTrackingRequestEmailList('OpenTrackRequestNewMode');
  }

  async function CheckTrackRequestAllowed(countToSend: number) {
    let result = '';

    const perMonth = appContext.suntekSettings?.company?.containersPerMonth ?? 0;
    if (perMonth > 0) {
      const apiResult = await appContext.api.checkThisMonthRequests();
      if (perMonth - apiResult < countToSend) {
        result = `Credit for containers per month is limited.
This request will cause additional fee.
Do you want to request this tracking?`;
      }
    }
    return result;
  }

  async function IsShippingLineSupported(vcScac: string, reqType: string) {
    let apiResult: ApiResult<string> = { success: false, result: '', message: '' };

    if (_.isEmpty(vcScac)) {
      await showGlobalOkDialog(<p>Vessel carrier was not given. Please retry with valid Master B/L number.</p>);
      return apiResult;
    }

    apiResult = await appContext.api.trackingCheckShippingLine(vcScac);

    if(!apiResult || !apiResult.success){
      await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>);
      return apiResult;
    }
    else {
      switch (apiResult.result) {
        case 'X':
          await showGlobalOkDialog(<p>Tracking Service does not support Vessel carrier {`[${vcScac}]`}.</p>);
          apiResult.success = false;
          break;
        case RequestType.bl:
          if (reqType !== RequestType.bl) {
            await showGlobalOkDialog(<p>Vessel carrier {`[${vcScac}] support only Master B/L tracking.`}
Please retry from Master B/L list.</p>);
            apiResult.success = false;
          }
          break;
      }
    }
    return apiResult;
  }

  async function CheckTrStatus(jobId: number, trType: string, trStatus: string, cntrCount: number = 1) {
    if (!_.isEmpty(trType) && trType !== 'C') {
      jobListContext.setRowExtrasId(jobId);
      jobListContext.setTrackingRequestEmailList('OpenTrackRequestViewMode');
      return false;
    }
    return true;
  }

  return {create, deleteItem, edit, view, copy, recognize, viewBillings, moveToDeleteHistoryReport, switchToAcctInfo, viewProfit, switchToContainerFor, trackRequestFunc};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteItem, edit, view, copy, recognize, viewBillings, viewProfit, switchToContainerFor, trackRequestFunc } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OtherOperationListItem;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const listSec = findSecurityTask(appContext, FmsSecTask.OtherOP);
  const fmsGlobal = getFmsGlobal();

  async function processFileLock() {
    const fileLockResult = await appContext.api.opClose(JobNames.OtherOP, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult);
      return;
    }

    if (selectedElement.isClosed && jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/otherShipment/edit/${selectedElement.id}`)) {
      const editModelKey = `editOtherShipment${selectedElement.id}-/otherShipment/otherShipment/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].isClosed = false;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;
      }
    }

    jobListContext.reloadData();
  }

  function openContainerStatus() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(selectedElement.id);
  }

  function openContainerTracking() {
    window.open(`https://trackinginfo.suntekscm.com/?licid=${fmsGlobal.AcmeID}&search=${selectedElement.mblNo}&email=${appContext.user?.email}`);
  }

  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock);
  let isTracking = (selectedElement?.trStatus && selectedElement?.trStatus !== 'C' && selectedElement?.trStatus !== 'failed' && selectedElement?.trStatus !== 'Q') ?? false;
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Go to Container List', shortcut: 'F4', separator: false },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'Bilings', shortcut: 'F7', separator: !listSec?.grantEdit },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: true, hidden: !listSec?.grantEdit },
    { label: 'Container Status Update', shortcut: '', separator: false },
    { label: 'CNTR Tracking Info', shortcut: '', separator: false },
    { label: isTracking ? 'Request Email Notification' : 'Request Tracking Service', shortcut: '', separator: false, hidden: !appContext.suntekSettings?.company?.trackingService },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
    // { label: 'Recog', shortcut: '', separator: false, disabled : selectedElement?.recognized === 'R', hidden: !getFmsGlobal().CanFinalize },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !getFmsGlobal().CanFinalize },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem  name="os-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteItem();
        break;
      case 4:
        switchToContainerFor();
        break;
      case 5:
        jobListContext.triggerTableSearch('F5');
        break;
      case 6:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 7:
        copy();
        break;
      case 8:
        viewBillings();
        break;
      case 9:
        viewProfit(listSec?.grantEdit ? true : false);
        break;
      case 10:
        openContainerStatus();
        break;
      case 11:
        openContainerTracking();
        break;
      case 12:
        trackRequestFunc();
        break;
      case 13:
        processFileLock();
        break;
      case 14:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OtherOperationListItem;
  const {switchJournal} = useJournal();
  const suntekSettings = useSuntekSettings();
  
  if (!suntekSettings.general?.allowViewJournalOP && !userId.startsWith('@')) {
    return null;
  }

  return (
    <PrimaryButton
      size="regular"
      onClick={()=> switchJournal(JobNames.OtherOP, selectedElement.id)}>
      {constants.List_Journal}
    </PrimaryButton>
  );
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  
  const selectedElement = jobListContext.selectedElement as OtherOperationListItem;

  const {deleteItem, edit, view, copy, viewBillings, moveToDeleteHistoryReport, trackRequestFunc} = useSelectedOperations();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const appContext = useContext(ApplicationContext);
  const { viewReport } = useReportViewer();
  const setSavedEntityJournal = useSetEditedId([JobNames.SlipJournal]);

  function hasOpenedViewOrEditFor(id: number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/otherShipment/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/otherShipment/view/${id}`);
  }

  function doAfterRecog() {
    jobListContext.reloadData();
    setSavedEntityJournal(selectedElement.id.toString(), false);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/otherShipment/otherShipment/add`);
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.OtherOP, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if(args){
      viewReport(args, "", true);
    }
  }

  const allowedStatuses = ['', 'E', 'D'];

  const listSec = findSecurityTask(appContext, FmsSecTask.OtherOP);

  const hasSelectedRow = !!selectedElement;
  // const canBeDeleted = hasSelectedRow && !hasOpenedViewOrEditFor(selectedElement.id) && selectedElement.canBeDeleted
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <UniqueLinkButton name='os-list-add-button' display="primary" size="regular" link="/otherShipment/otherShipment/add" disabled={!canBeAdd} label="New"/>&nbsp;
        <PrimaryButton name='os-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name='os-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name='os-list-delete-button' size="regular" disabled={!canBeDeleted} onClick={deleteItem}>Delete</PrimaryButton>&nbsp;
        <PrimaryButton name='os-list-copy-button' size="regular" disabled={!canBeCopied} onClick={copy}>Copy</PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <PrimaryButton size="regular" onClick={viewBillings}>{constants.List_Billings}</PrimaryButton>&nbsp;
        <PrimaryButton size="regular" onClick={moveToDeleteHistoryReport}>Delete History</PrimaryButton>&nbsp;
        <PrimaryButton size="regular" onClick={() => trackRequestFunc()}>Tracking RQ</PrimaryButton>
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.id} mTbName={"T_GENMAIN"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const listSec = findSecurityTask(appContext, FmsSecTask.OtherOP);

  const {copy, create, edit, view, viewBillings, viewProfit, switchToContainerFor} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === 'F4'){
      switchToContainerFor();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
    } else if (unprocessedFkey === "F7") {
      viewBillings();
    }else if (unprocessedFkey === "CTRL+F7") {
      viewProfit(listSec?.grantEdit ? true : false);
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F4', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

/*
  function onLinkToAccounting(entity: any) {
    if (!entity || !entity.category || !entity.number) {
      return;
    }

    if (entity.category === 'Bill') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/bill/otherShipment', 'billNo', 'Bill No', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/bill/otherShipment`, NavigationType.newPage);
    }
    if (entity.category === 'Invoice') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/invoice/otherShipment', 'invoiceNo', 'Invoice No', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/invoice/otherShipment`, NavigationType.newPage);
    }
    if (entity.category === 'CrDb') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/crdb/otherShipment', 'crdbNo', 'CrDb No', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/crdb/otherShipment`, NavigationType.newPage);
    }
  }
*/

  // async function loadInfoAreaInvoiceBillCrDb(id: string) {
  //   const apiResult = await appContext.api.getOceanImportMblInfoAreaBics(id);
  //   if (!apiResult) {
  //     return null;
  //   }

  //   const tableOptions: ApplicableTableSettings = {
  //     tableName: 'infoAreaBicTable',
  //     ...infoAreaBicTable,
  //     data: apiResult,
  //     
  //     rowRenderers: [
  //       {accessor: 'date', Cell: TextRenderer},
  //       {accessor: 'category', Cell: TextRenderer},
  //       // @ts-ignore:next-line
  //       {accessor: 'number', Cell: AccountingEntityRenderer.bind(this, onLinkToAccounting)},
  //       {accessor: 'companyName', Cell: TextAlignLeftRenderer},
  //       {accessor: 'cur', Cell: TextRenderer},
  //       // @ts-ignore:next-line
  //       {accessor: 'amount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.amount, cell.row.values.cur)},
  //       // @ts-ignore:next-line
  //       {accessor: 'paidAmount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.paidAmount, cell.row.values.cur)},
  //       // @ts-ignore:next-line
  //       {accessor: 'balance', Header: () => <div style={{marginRight: '8px'}}>Balance</div>, Cell: ({cell}) => CurrencyRenderer(cell.row.values.balance, cell.row.values.cur, true)},
  //     ],
  //   };

  //   return (
  //     <div style={{width: `${infoAreaBicTable.width}`, marginLeft: 'auto', marginRight: 'auto'}}>
  //       <SmartTable {...tableOptions} />
  //     </div>
  //   );
  // }
  
  const infoHeadline = `Ref #: ${(jobListContext.selectedElement as OtherOperationListItem|null)?.refNo ?? ''}`;

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.otherShipmentMbl}
      jobName={JobNames.OtherOP}
      //entityId={(jobListContext.selectedElement as OtherOperationListItem | null)?.id}
      jobId={(jobListContext.selectedElement as OtherOperationListItem | null)?.id ?? 0}
      customTabs={[
        {
          headline: 'Billings Info',
          contentLoader: loadInfoAreaInvoiceBillCrDb,
          params: { appContext, jobListContext, history, infoHeadline }
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

function formatData(data:Array<OtherOperationListItem>) {
  return data.map(d => ({
    ...d,
    shipmentType: formatShipmentType(d.shipmentType ?? ''),
  }));
}

/**
 * Concrete implementation for Other Shipment List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {

  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.OtherOP,
      'OtherOperationListItem',
      OtherOperationListItem.calculateSearchParameters(search, OtherOperationListItem.MapSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat']),
      1,
      search.pageSize,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'recognized',
        renderer: RecognizedFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'shipmentType',
        renderer: ShipmentTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'invStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'billStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'crDbStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'trStatus',
        renderer: RQFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings, listCount: number, useDarkMode: boolean): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    return OtherOperationListItem.getExportCollection(useBranch).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if (x.dataIndex === 'pStatus') colRenderer.Cell = PaidRenderer;
      else if (x.dataIndex === 'useIsfNo') colRenderer.Cell = IsfRenderer;
      else if (x.dataIndex === 'itNo') colRenderer.Cell = InbondRenderer;
      else if(x.dataIndex === "shipmentType") colRenderer.Cell = ShipmentTypeRenderer;
      else if (x.dataIndex === 'recognized') {
          colRenderer.Cell = RecognizedRenderer;
      }
      else if(x.dataIndex === 'invStat' || x.dataIndex === 'billStat' || x.dataIndex === 'crDbStat') colRenderer.Cell = BillingsRenderer;
      else if(x.dataIndex === "refNo") colRenderer.Cell = TextAlignLeftRenderer;
      else if(x.dataIndex === 'trStatus'){
        colRenderer.Cell = (props: any) => <LastEventRenderer {...props} jobName={JobNames.OtherOP} />;
        colRenderer.Header =  () => <div><img style={{float:'left'}} height="16px" src={useDarkMode ? cntrWhite : cntrBlack} alt='' />Container Tracking</div>;
      }
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'pkgs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'useIsfNo', changedValue: (value: any)=> { return nullableCheckBoxValue(value['useIsfNo'])}});
    colRenderer.push({ accessor: 'pkgs', changedValue: (value: any) => { return value['pkgs'] } });
    colRenderer.push({ accessor: 'lbs', changedValue: (value: any) => { return Decimalformat(value['lbs'],2) } });
    colRenderer.push({ accessor: 'kgs', changedValue: (value: any) => { return Decimalformat(value['kgs'],2) } });
    colRenderer.push({ accessor: 'shipmentType', changedValue: (value: any) => { return formatShipmentType(value['shipmentType']) } });
    colRenderer.push({accessor: 'trStatus', changedValue: (value: any)=> { 
      let text = '';
      if(value['trType'] === 'C' || value['trType'] === 'M'){
        switch(value['trStatus']){
          case 'Q':
            text = 'Start to Request';
            break;
          case 'failed':
            text = 'Invalid or Error';
            break;
          case 'tracking_stopped':
            text = 'End of Tracking';
            break;
          default:
            text = 'Under Movement';
            break;
        }
      }
      return text;
    }});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'u2Date',
      orderByAscending: false,
    };
  }

  renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any): React.ReactNode | null {
    if (!rowId) return null;

    function onCloseMilestonePopup() {
      const storageKey = `ot-mbl-milestone-${rowId}`;
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
    }

    function onCloseTracking49Popup() {
      const storageKey = `ot-container-trackrequest-${rowId}`;
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
      context.setTrackingRequestEmailList(undefined);
      vcResult = '';
    }

    function getTrackRequestTitle(trStatus: string) {
      return 'Tracking Request' + (!_.isEmpty(trStatus) && trStatus !== 'Q' ? ` - ${trStatus.toUpperCase().replace('_', ' ')}` : '');
    }
    
    if (!_.isUndefined(context.trackingRequestEmailList)) {
      return (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onCloseTracking49Popup} draggable isOpen title={getTrackRequestTitle(cell.row.original.trStatus)} width="500px">
          <TrackingRequest
            jobId={rowId}
            storageKey={`ot-container-trackrequest-${rowId}`}
            onClose={onCloseTracking49Popup}
            jobName={JobNames.OtherOP}
            trStatus={cell.row.original.trStatus}
            trType={!_.isUndefined(context.trackingRequestEmailList) && context.trackingRequestEmailList !== 'OpenTrackRequestViewMode' ? (vcResult === RequestType.bl ? 'M' : 'C') : cell.row.original.trType}
            mode={!_.isUndefined(context.trackingRequestEmailList) && context.trackingRequestEmailList !== 'OpenTrackRequestViewMode' ? 'new' : 'view'}
            vcResult={vcResult}
            containerNo={cell.row.original.container}
          />
        </IfmsModal>
      );
    }
    else
    return (
      <IfmsModal isBlueHeader cancelOnEsc onCancel={onCloseMilestonePopup} draggable isOpen title="Container Status Update" width="760px">
        <MblMilestonePopup mblId={rowId} storageKey={`ot-milestone-${rowId}`} onClose={onCloseMilestonePopup} isView={false} />
      </IfmsModal>
    );
  }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings =  otherShipmentList;
    const useBranch = systemSettings?.enableBranch ?? false;
    const cols = OtherOperationListItem.getExportCollection(useBranch);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras(hideLogHistory: boolean) {
    return <ListViewExtras hideLogHistory={hideLogHistory} />
  }

  getViewUrlFor(row: OtherOperationListItem) {
    return row && row.id ? `/otherShipment/otherShipment/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Other Shipment List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.OtherOP} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
  
  useLogHistory(): boolean {
    return true;
  }
}

export default ListView;
